/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { Map, fromJS, List } from 'immutable';
import { RestAPI } from '@/util/net';
import { putError } from '@/store/error.store';
import { REF_NAME as ProductName } from '../component/dict/complex/product/Const';
import { replace } from 'react-router-redux';

const productSelected = (state, action) =>
  state.set('productRow', action.id).set('productPage', action.page);


const profileLoaded = (state, action) =>
  state.set('profile', action);

const dealsPage = (state, action) =>
  state.setIn(['dealsPage', action.dealType], action.pageNumber)
    .setIn(['dealsPageSize', action.dealType], action.pageSize);

// const clearPagination = (state) =>
//   state.delete('dealsPage').delete('dealsPageSize');

const saveEntryPoint = (state, key) =>
  state.set('entryPointKey', key);

const saveFormChanged = (state, bool) => {
  if (bool) {
    let newState;
    if (!state.get('formChanged')) {
      newState = state.set('formChanged', true);
    }
    if (state.get('autosaved')) {
      newState = state.set('autosaved', false);
    }
    return newState || state;
  } return state.set('formChanged', false);
};
const openNewDeal = (state, dealType) =>
  saveFormChanged(state, false).set('dealType', dealType).delete('autosaved');

const clearEditDealType = (state) => state.delete('dealType');

const scrollToTop = (state, bool) => state.set('scrollToTop', bool);

const storeDealCopy = (state, data, dealType) => {
  let newDeal = fromJS(data).set('dealType', dealType).delete('id');
  newDeal = newDeal.set('products',
    newDeal.get('products', new List()).map(p => p.set('payment', ''))
  );
  return state.set('dealCopy', newDeal).set('formChanged', false);
};

const clearDealCopy = (state) => state.delete('dealCopy');

const operationUsersLoaded = (state, data) => state.set('operations', fromJS(data));
const charteringUsersLoaded = (state, data) => state.set('chartering', fromJS(data));
const traderUsersLoaded = (state, data) => state.set('traders', fromJS(data));

export const allAroundReducer = (state = Map(), action) => {
  switch (action.type) {
    case `${ProductName}_SELECTED`:
      return productSelected(state, action);
    case 'PROFILE_LOADED':
      return profileLoaded(state, action.data);
    case 'DEALS_PAGE_SWITCHED':
      return dealsPage(state, action);
    case 'DEALS_TYPE_SWITCHED':
      return state;
      // return clearPagination(state);
    case 'ENTRY_POINT_SAVED':
      return saveEntryPoint(state, action.key);
    case 'FORM_CHANGED':
      return saveFormChanged(state, true);
    case 'FORM_CHANGES_IGNORE':
      return saveFormChanged(state, false);
    case 'CLEAR_DEAL':
      return openNewDeal(state, action.dealType)
        .delete('bulkExpensesConstructed');
    case 'CLEAR_DEAL_EDIT_TYPE':
      return clearEditDealType(state);
    case 'DEAL_SAVING_SUCCESS':
      return scrollToTop(state, true)
        .set('autosaved', true)
        .set('dealCreated', true)
        .delete('formChanged');
    case 'DEAL_UPDATE_SUCCESS':
      return state.set('autosaved', true)
        .set('dealUpdated', true)
        .delete('formChanged');
    case 'SCROLLED_TO_TOP':
      return scrollToTop(state, false);
    case 'SAVE_IN_ACTION':
    case 'LOADING_DEAL':
      return state.set('saving', true).delete('autosaved');
    case 'SAVE_FINISHED':
    case 'DEAL_LOADING_FAILED':
      return state.set('saving', false);
    case 'DEAL_SAVE_ATTEMPT_FAILED':
    case 'DEAL_UPDATE_ATTEMPT_FAILED':
      return state.set('autosaved', false);
    case 'SAVED_NEW_CHANGELOG_VERSION':
      return state.set('changelogVersion', action.version);
    case 'EXPENSES_REBUILDED':
      return state.setIn(['expensesRebuilded', action.id], true);
    case 'BULK_EXPENSES_CONTRUCTED':
      return state.setIn(['expensesRebuilded', action.id], false);
    case 'DEAL_LOADED':
      return state.delete('expensesRebuilded').set('saving', false);
    case 'STARTING_GLOBAL_SEARCH':
      return state.set('globalSearchInProgress', true).set('globalSearchText', action.text);
    case 'GLOBAL_SEARCH_CLEARED':
      return state.delete('globalSearchText');
    case 'SEARCH_FINISHED':
      return state.delete('globalSearchInProgress');
    case 'DEAL_COPY_LOADED':
      return storeDealCopy(state, action.data, action.dealType);
    case 'CLEAR_COPY':
      return clearDealCopy(state);
    case 'USE_MOBILE_VERSION':
      return state.set('useMobileVersion', !!action.value);
    case 'OPERATION_USERS_LOADED':
      return operationUsersLoaded(state, action.data);
    case 'CHARTERING_USERS_LOADED':
      return charteringUsersLoaded(state, action.data);
    case 'TRADER_USERS_LOADED':
      return traderUsersLoaded(state, action.data);
    case 'CLEAR_NOTIFICATION':
      return state.delete(action.name);
    case 'AVOID_REPORT_RESET':
      return state.set('avoidReportReset', action.val);
    case 'REPORT_RESET_CONFIRMED':
      return state.delete('avoidReportReset');
    default:
      return state;
  }
};

export const clearNotification = (dispatch, name) => {
  dispatch({ type: 'CLEAR_NOTIFICATION', name });
};

export const avoidReportReset = (dispatch, val = true) => {
  dispatch({ type: 'AVOID_REPORT_RESET', val });
};

export const reportResetConfirm = (dispatch) => {
  dispatch({ type: 'REPORT_RESET_CONFIRMED' });
};

export const selectDealsPage = (dispatch, pageNumber, pageSize, dealType) => {
  dispatch({ type: 'DEALS_PAGE_SWITCHED', pageNumber, pageSize, dealType });
  dispatch(replace(`${window.location.pathname}?pageNumber=${pageNumber}&pageSize=${pageSize}`));
};

export const dealsTypeSwitch = (dispatch) => {
  dispatch({ type: 'DEALS_TYPE_SWITCHED' });
};

export const selectRow = (dispatch, refName, prodId, pageNumber) => {
  dispatch({ type: `${refName}_SELECTED`, id: prodId, page: pageNumber });
};

export const loadProfile = (dispatch) => {
  dispatch({ type: 'PROFILE_LOADING_STARTED' });
  return RestAPI.get('/users/profile/api').then((data) => {
    dispatch({ type: 'PROFILE_LOADED', data });
    return true;
  });
};
export const saveEntryPointKey = (dispatch, key) => {
  dispatch({ type: 'ENTRY_POINT_SAVED', key });
};
export const handleFormChanged = (dispatch) => {
  dispatch({ type: 'FORM_CHANGED' });
};
export const ignoreFormChanged = (dispatch) => {
  dispatch({ type: 'FORM_CHANGES_IGNORE' });
};
export const scrolledToTop = (dispatch) => {
  dispatch({ type: 'SCROLLED_TO_TOP' });
};
export const saveInAction = (dispatch) => {
  dispatch({ type: 'SAVE_IN_ACTION' });
};
export const saveFinished = (dispatch) => {
  dispatch({ type: 'SAVE_FINISHED' });
};
export const saveChangelogVersion = (dispatch, version) => {
  dispatch({ type: 'SAVED_NEW_CHANGELOG_VERSION', version });
};
export const setBulkExpensesConstructed = (dispatch, id) => {
  dispatch({ type: 'BULK_EXPENSES_CONTRUCTED', id });
};
export const setExpensesRebuilded = (dispatch, id) => {
  dispatch({ type: 'EXPENSES_REBUILDED', id });
};

export const clearCopy = (dispatch) => dispatch({ type: 'CLEAR_COPY' });

export const loadDealCopy = (dispatch, dealType, sourceId) => {
  dispatch({ type: 'LOADING_SOURCE_DEAL' });
  return RestAPI.get(`/deals/${dealType}/api/copy/${sourceId}`)
    .then(
      (data) => {
        dispatch({ type: 'DEAL_COPY_LOADED', data, dealType });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'DEAL_COPY_FAILED' });
        return true;
      },
    );
};

export const useMobileVersion = (dispatch, value) =>
  dispatch({ type: 'USE_MOBILE_VERSION', value });

export const loadOperationUsers = (dispatch) => {
  dispatch({ type: 'LOADING_OPERATION_USERS' });
  return RestAPI.get('/users/api/alloperators/')
    .then(
      (data) => {
        dispatch({ type: 'OPERATION_USERS_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'OPERATION_USERS_LOADING_FAILED' });
        return true;
      },
    );
};

export const loadCharteringUsers = (dispatch) => {
  dispatch({ type: 'LOADING_CHARTERING_USERS' });
  return RestAPI.get('/users/api/allchartering/')
    .then(
      (data) => {
        dispatch({ type: 'CHARTERING_USERS_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'CHARTERING_USERS_LOADING_FAILED' });
        return true;
      },
    );
};

export const loadTraderUsers = (dispatch) => {
  dispatch({ type: 'LOADING_TRADER_USERS' });
  return RestAPI.get('/users/api/alltraders/')
    .then(
      (data) => {
        dispatch({ type: 'TRADER_USERS_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'TRADER_USERS_LOADING_FAILED' });
        return true;
      },
    );
};
